import {
  GET_SALUTATION,
  GET_GENDER,
  GET_REPORT_TYPE,
  GET_CASE_INFORMATION,
  ADD_PRODUCT_INFO,
  GET_PATIENT_INFO,
  GET_NARRATIVE_SUMMARY,
  GET_CASE_EVENT_INFO,
  GET_PRIMARY_SOURCE,
  UPDATE_CASES_ID,
  GET_PRODUCT_INFO,
  GET_PRODUCT_REACT,
  OLD_REPORTVALUE,
  OLD_GENERALVALUE,
  OLD_PATIENTVALUE,
  OLD_PRODUCTVALUE,
  OLD_EVENTVALUE,
  OLD_REACTIONVALUE,
  OLD_NARRATIVEVALUE,
  GET_ALL_DURATIONS_DETAILS,
  IS_CASE_PAGE,
} from '../../types'

const INITIAL_STATE = {
  allSalutation: [],
  allGender: [],
  allRepotType: [],
  caseInformation: {},
  patientInformation: {},
  narrativeSummary: {},
  primarySource: [],
  addproductInfo: [],
  eventInfo: [],
  updateCases: [],
  productInfoData: [],
  productReaction: {},
  oldReportValue: {},
  oldGeneralValue: {},
  oldPatientValue: {},
  oldProductValue: {},
  oldEventValue: {},
  oldReactionValue: {},
  oldNarrativeValue: {},
  getAllDuration: [],
  isCasePage:false,
}

const basicCaseReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_SALUTATION:
      return {
        ...state,
        allSalutation: payload,
      }
    case GET_GENDER:
      return {
        ...state,
        allGender: payload,
      }
    case GET_REPORT_TYPE:
      return {
        ...state,
        allRepotType: payload,
      }
    case GET_CASE_INFORMATION:
      return {
        ...state,
        caseInformation: payload,
      }
    case GET_PRIMARY_SOURCE:
      return {
        ...state,
        primarySource: payload,
      }
    case ADD_PRODUCT_INFO:
      return {
        ...state,
        addproductInfo: payload[0],
      }
    case GET_PATIENT_INFO:
      return {
        ...state,
        patientInformation: payload,
      }
    case GET_NARRATIVE_SUMMARY:
      return {
        ...state,
        narrativeSummary: payload,
      }
    case GET_CASE_EVENT_INFO:
      return {
        ...state,
        eventInfo: payload,
      }
    case UPDATE_CASES_ID:
      return {
        ...state,
        updateCases: payload,
      }
    case GET_PRODUCT_INFO:
      return {
        ...state,
        productInfoData: payload,
      }
    case GET_PRODUCT_REACT:
      return {
        ...state,
        productReaction: payload,
      }
    case OLD_GENERALVALUE:
      return {
        ...state,
        oldGeneralValue: payload,
      }

    case OLD_REPORTVALUE:
      return {
        ...state,
        oldReportValue: payload,
      }
    case OLD_PATIENTVALUE:
      return {
        ...state,
        oldPatientValue: payload,
      }
    case OLD_PRODUCTVALUE:
      return {
        ...state,
        oldProductValue: payload,
      }
    case OLD_EVENTVALUE:
      return {
        ...state,
        oldEventValue: payload,
      }
    case OLD_REACTIONVALUE:
      return {
        ...state,
        oldReactionValue: payload,
      }
    case OLD_NARRATIVEVALUE:
      return {
        ...state,
        oldNarrativeValue: payload,
      }

    case GET_ALL_DURATIONS_DETAILS:
      return {
        ...state,
        getAllDuration: payload,
      }
      case IS_CASE_PAGE:
        return {
          ...state,
          isCasePage: payload,
        }
    default:
      return state
  }
}

export default basicCaseReducer
